module.exports = __webpack_public_path__ + "img/orderIcon.ebb51207.png";